module.exports = __webpack_public_path__ + "media/admin/cs_publication_request_001_sm-f39beb94.png";